// Person-name charset validation (mirror of backend/src/utils/nameValidation.ts).
// Allows letters of ANY script (Latin, 汉字, кириллица, العربية, かな, …),
// combining marks, digits, spaces, and separators found in real names: . ' ’ -
// Rejects other symbols/emoji. The `u` flag is REQUIRED for \p{...} and for
// non-Latin scripts to pass. Keep in sync with the backend copy.
export const NAME_REGEX = /^[\p{L}\p{M}\p{N} .'’-]+$/u;

// True when empty (required-ness handled elsewhere) or charset is valid.
export function isValidPersonName(value) {
  if (value === null || value === undefined) return true;
  const str = String(value).trim();
  if (str.length === 0) return true;
  return NAME_REGEX.test(str);
}
